import { useSettings } from "@src/context/SettingsContext";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useAuthorizedRoutes } from "@src/hooks/useAuthorizedRoutes";
import { renderRouteIcon } from "@src/utils/renderRouteIcon";

const DrawerContainer = styled.div<{ $isClosed: boolean }>`
  min-width: 270px;
  background-color: ${({ theme }): string => theme.colors.gray300};
  position: ${({ $isClosed }): string => ($isClosed ? "absolute" : "relative")};
  z-index: 100;
  box-shadow: ${({ $isClosed }): string =>
    $isClosed ? "none" : "0px 0px 10px rgba(0, 0, 0, 0.5)"};
  max-height: calc(100vh - 65px); //max height of the content area (TopBar 65)
  min-height: calc(100vh - 65px); //min height of the content area (TopBar 65)
  overflow-y: auto;
  transition: transform 0.3s ease;
  transform: ${({ $isClosed }): string =>
    $isClosed ? "translateX(-100%)" : "translateX(0)"};
  @media (min-width: 1161px) {
    display: none;
  }
`;
const Divider = styled.hr`
  border: 1px solid ${({ theme }): string => theme.colors.gray};
  opacity: 0.3;
  margin: 0;
`;
const DrawerContent = styled.div<{ $isClosed: boolean }>``;

const MenuItem = styled.button<{ $active?: boolean }>`
  width: 100%;
  min-height: 50px;
  cursor: pointer;
  text-align: left;
  padding: 0 20px;
  background-color: transparent;
  color: ${({ theme }): string => theme.colors.gray};
  border: none;
  font-size: 22px;
  color: ${({ $active, theme }): string =>
    $active ? theme.colors.yellow : theme.colors.gray};
  &:hover {
    background-color: ${({ theme }): string => theme.colors.darkGray};
  }
  &:focus {
    outline: 1px solid ${({ theme }): string => theme.colors.yellow};
  }
  &:hover {
    background-color: ${({ theme }): string => theme.colors.gray200};
  }
`;

const SideNavMenu = (): React.JSX.Element => {
  const { isSideNavMenuOpen } = useSettings();
  const navigate = useNavigate();
  const location = useLocation();
  const routes = useAuthorizedRoutes();

  const ItemComponent = ({
    $active,
    item,
  }: {
    $active: boolean;
    item: { title: string; path: string };
  }): React.JSX.Element => {
    return (
      <>
        <MenuItem $active={$active} onClick={(): void => navigate(item.path)}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <span
              style={{
                display: "flex",
                width: "24px",
                justifyContent: "center",
              }}
            >
              {renderRouteIcon({
                route: item.path,
                active: $active,
                title: item.title,
                isSideNav: true,
              })}
            </span>
            <span>{item.title}</span>
          </div>
        </MenuItem>
        <Divider />
      </>
    );
  };

  return (
    <DrawerContainer
      className="scrollbar-style-2"
      $isClosed={!isSideNavMenuOpen}
    >
      <DrawerContent $isClosed={isSideNavMenuOpen}>
        <Divider />
        {routes.map((route, index) => {
          return (
            <ItemComponent
              $active={location.pathname === route.path}
              key={index}
              item={route}
            />
          );
        })}
      </DrawerContent>
    </DrawerContainer>
  );
};

export default SideNavMenu;
